<section class="header-img-wrapper">
    <div class="container-full-img">
        <ng-container *ngFor="let item of INewsContent">
            <picture *ngIf="item.imageLg">
                <source media="(min-width: 992px)" srcset="{{item.imageLg}}">
                <source media="(min-width: 480px)" srcset="{{item.imageMd}}">
                <source media="(min-width: 0px)" srcset="{{item.imageSm}}">
                <img class="img-responsive" src="{{item.imageLg}}"
                     alt="Alexander Koenig">
            </picture>
        </ng-container>
    </div>
</section>
<section id="wrapper" class="container content-wrapper detail">
    <article>
        <div class="row">
            <div class="col-xs-12 col-sm-8">
                <ng-container *ngFor="let item of INewsContent">
                    <h2 *ngIf="item.name"> {{item.name}}</h2>
                    <span *ngIf="item.date">{{item.date}}</span>
                    <p *ngIf="item.content_detail" [innerHTML]="item.content_detail">{{item.content_detail}}</p>
                </ng-container>
            </div>
            <aside class="col-xs-12 col-sm-4" *ngIf="IPhotoItem.length >= 0">
                <h3>Bilder zum Event</h3>
                <ng-container *ngFor="let items of IPhotoItem">
                    <img (click)="openDialog(items)" class="lazy-image" width="75px" src="{{items.imageSm}}"
                         alt="{{items.alt}}"/>

                </ng-container>
            </aside>
        </div>
    </article>
</section>

